export default __webpack_public_path__ + "static/media/hizmetlerimiz.0d5a1002.jpg";